import script from "./PortfolioList.vue?vue&type=script&setup=true&lang=ts"
export * from "./PortfolioList.vue?vue&type=script&setup=true&lang=ts"

import "./PortfolioList.vue?vue&type=style&index=0&id=8e9e67b2&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e9e67b2"]])

export default __exports__